import React from 'react'
import PropTypes from 'prop-types'
import { PROPERTY_TYPE_SINGULAR } from 'Config/config'
import SvgIcon from 'Components/SvgIcon'
import { ESTIMATE_BASE_URL } from 'Defaults'

import { _Card, _Heading, _IconWrapper, _PrimaryButton, _SecondaryButton, _Text, _TextContainer, _BtnContainer } from './styles'


const EstimateCTA = ({ googleAnalyticsEvent = () => {} }) => {
  const eventHandler = (action) => googleAnalyticsEvent({
    category: 'Listing',
    action,
  })
  return (
    <_Card>
      <_IconWrapper>
        <SvgIcon name="#icon-estimate-icon" width="126" height="130" />
      </_IconWrapper>
      <_TextContainer>
        <_Heading>
          <span>Have a home?</span> See what it&apos;s worth with an instant estimate
        </_Heading>
        <_Text>
          Use our AI-assisted tool to get an instant estimate of your home&apos;s value,
          up-to-date neighbourhood sales data, and tips on how to sell for more.
        </_Text>
        <_BtnContainer>
          <_PrimaryButton
            primary
            url={ESTIMATE_BASE_URL}
            onClick={() => eventHandler('[GetEstimate Btn Click]')}
          >
            Get an Estimate
          </_PrimaryButton>
          <_SecondaryButton
            secondary
            url={`/sell-my-${PROPERTY_TYPE_SINGULAR}`}
            onClick={() => eventHandler('[LearnAboutSelling Btn Click]')}
          >
            Learn More About Selling
          </_SecondaryButton>
        </_BtnContainer>
      </_TextContainer>
    </_Card>
  )
}
EstimateCTA.propTypes = {
  googleAnalyticsEvent: PropTypes.func,
}

export default EstimateCTA
